export default __webpack_public_path__ + "7043f6f1d0731de0cc0943e896c32fca.jpg";